"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_application_1 = require("@ryerson/frontend.application");

var SearchResultItemDesktop_1 = __importDefault(require("./SearchResultItemDesktop"));

var frontend_common_1 = require("@ryerson/frontend.common");

var SearchResultItemMobile_1 = __importDefault(require("./SearchResultItemMobile"));

var SearchResultItem = function SearchResultItem(_ref) {
  var isMobile = _ref.isMobile,
      item = _ref.item,
      storeDirectory = _ref.storeDirectory,
      deliveryTimes = _ref.deliveryTimes,
      setDeliveryTimes = _ref.setDeliveryTimes,
      stateMessenger = _ref.stateMessenger,
      setSearchText = _ref.setSearchText,
      setTriggerDeliveryTimes = _ref.setTriggerDeliveryTimes;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      profile = _ref2.profile; // Create Default UOM options for quantity and Pricing


  var _ref3 = (0, frontend_common_1.getUsersDefaultUomValue)(item, profile),
      qtyUomOption = _ref3.qtyUomOption,
      pricingUomOption = _ref3.pricingUomOption;

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [!isMobile && (0, jsx_runtime_1.jsx)(SearchResultItemDesktop_1.default, {
      item: item,
      storeDirectory: storeDirectory,
      deliveryTimes: deliveryTimes,
      setDeliveryTimes: setDeliveryTimes,
      setTriggerDeliveryTimes: setTriggerDeliveryTimes,
      setSearchText: setSearchText,
      stateMessenger: stateMessenger,
      qtyUomOption: qtyUomOption,
      pricingUomOption: pricingUomOption
    }), isMobile && (0, jsx_runtime_1.jsx)(SearchResultItemMobile_1.default, {
      item: item,
      storeDirectory: storeDirectory,
      deliveryTimes: deliveryTimes,
      setDeliveryTimes: setDeliveryTimes,
      setTriggerDeliveryTimes: setTriggerDeliveryTimes,
      stateMessenger: stateMessenger,
      qtyUomOption: qtyUomOption,
      pricingUomOption: pricingUomOption
    })]
  });
};

exports.default = SearchResultItem;